<script lang="ts">
  import { Wrapper } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  const BLURB_BACKGROUNDS = {
    'did-you-know': '#0094FF',
    'fun-fact': '#702DC6',
    'quick-tip': '#12B75F',
  };

  $: blockType = properties.items.find(element => element.active);
  $: backgroundColor = BLURB_BACKGROUNDS[blockType.key || 'did-you-know'];
</script>

<Wrapper
  style="display:flex;align-items: center;justify-content: center;background:var(--vlt-lp-background);"
>
  {#if properties}
    <div
      class="wrapper"
      style="background:{backgroundColor}0D;border-color:{backgroundColor}2E;"
    >
      <div class="icon">
        {#if blockType.key === 'did-you-know'}
          <!-- Did you know-->
          <svg
            style="color:{backgroundColor};"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.833 36.6667H24.1663M24.9997 25.544C28.9413 23.6716 31.6663 19.654 31.6663 15C31.6663 8.55672 26.443 3.33337 19.9997 3.33337C13.5564 3.33337 8.33301 8.55672 8.33301 15C8.33301 19.654 11.0581 23.6716 14.9997 25.544V26.6667C14.9997 28.2198 14.9997 28.9964 15.2534 29.609C15.5917 30.4257 16.2406 31.0747 17.0574 31.413C17.67 31.6667 18.4465 31.6667 19.9997 31.6667C21.5528 31.6667 22.3294 31.6667 22.942 31.413C23.7587 31.0747 24.4076 30.4257 24.7459 29.609C24.9997 28.9964 24.9997 28.2198 24.9997 26.6667V25.544Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        {/if}

        {#if blockType.key === 'fun-fact'}
          <!-- Fun facts-->
          <svg
            style="color:{backgroundColor};"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.9997 15H25.0163M14.9997 15H15.0163M36.6663 20C36.6663 29.2048 29.2044 36.6667 19.9997 36.6667C10.7949 36.6667 3.33301 29.2048 3.33301 20C3.33301 10.7953 10.7949 3.33337 19.9997 3.33337C29.2044 3.33337 36.6663 10.7953 36.6663 20ZM25.833 15C25.833 15.4603 25.4599 15.8334 24.9997 15.8334C24.5394 15.8334 24.1663 15.4603 24.1663 15C24.1663 14.5398 24.5394 14.1667 24.9997 14.1667C25.4599 14.1667 25.833 14.5398 25.833 15ZM15.833 15C15.833 15.4603 15.4599 15.8334 14.9997 15.8334C14.5394 15.8334 14.1663 15.4603 14.1663 15C14.1663 14.5398 14.5394 14.1667 14.9997 14.1667C15.4599 14.1667 15.833 14.5398 15.833 15ZM19.9997 29.1667C24.1672 29.1667 27.4997 26.1117 27.4997 23.3334H12.4997C12.4997 26.1117 15.8322 29.1667 19.9997 29.1667Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        {/if}

        {#if blockType.key === 'quick-tip'}
          <!-- Quick Tips-->
          <svg
            style="color:{backgroundColor};"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.1663 31.6667L27.4997 35L34.9997 27.5M36.6416 20.9165C36.658 20.6131 36.6663 20.3075 36.6663 20C36.6663 10.7953 29.2044 3.33337 19.9997 3.33337C10.7949 3.33337 3.33301 10.7953 3.33301 20C3.33301 29.0591 10.5605 36.43 19.5638 36.6611M19.9997 10V20L26.2303 23.1154"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        {/if}
      </div>

      <div class="heading" style="color:var(--vlt-lp-text);">
        {blockType.heading}
      </div>

      <div class="content" style="color:var(--vlt-lp-text);">
        {@html blockType.content}
      </div>
    </div>
  {/if}
</Wrapper>

<style>
  .wrapper {
    text-align: center;
    max-width: 1200px;
    padding: 30px 20px 40px 20px;
    border: 1px solid;
    border-radius: 8px;
    margin: 0 20px;
    width: 100%;
  }
  .icon {
    display: inline-block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .heading {
    margin: 0 auto 16px;
    max-width: 800px;
    text-align: center;
    font-size: 24px;
    font-family: var(--text-font-heading);
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
  }
  .content {
    max-width: 800px;
    margin: 0 auto;
    font-family: var(--text-font-paragraph);
  }
  @media screen and (max-width: 767px) {
    .heading {
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
      margin: 0 auto 12px;
    }
    .content {
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }
  }
</style>
